import { Component, OnInit, Inject} from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { NgxSpinnerService } from 'ngx-spinner';
import { Common } from '../../shared/global/common';
import { Subject } from 'rxjs';

import { delay, filter, takeUntil } from 'rxjs/operators';

import {  MSAL_GUARD_CONFIG, MsalGuardConfiguration } from '@azure/msal-angular';
import { MsalBroadcastService,  MsalService } from '@azure/msal-angular';

import { EventMessage, EventType, AuthenticationResult, InteractionStatus, InteractionType } from '@azure/msal-browser';
import { Parent_Permision } from '../../shared/sidebar/model';
import { RequestData } from '../../shared/Model/RequestData';
import Swal from 'sweetalert2';
import { Claims } from '../../shared/sidebar/Claims';


const GRAPH_ENDPOINT = 'https://graph.microsoft.com/v1.0/me';
type ProfileType = {
  givenName?: string,
  surname?: string,
  userPrincipalName?: string,
  id?: string
};

@Component({
  selector: 'app-default',
  templateUrl: './default.component.html',
  styleUrls: ['./default.component.css']
})
export class DefaultComponent implements OnInit {

  loginDisplay = false;
  displayedColumns: string[] = ['claim', 'value'];
  dataSource: Claims[] = [];
  private readonly _destroying$ = new Subject<void>();

  constructor(private authService: MsalService, private msalBroadcastService: MsalBroadcastService,private SpinnerService: NgxSpinnerService,private http: HttpClient, @Inject(MSAL_GUARD_CONFIG) private msalGuardConfig: MsalGuardConfiguration ) { }

  ngOnInit(): void {

    this.msalBroadcastService.inProgress$
      .pipe(
        filter((status: InteractionStatus) =>  status === InteractionStatus.None || status === InteractionStatus.HandleRedirect),
        takeUntil(this._destroying$)
      )
      .subscribe(() => {
        this.checkAndSetActiveAccount();
        this.getClaims(this.authService.instance.getActiveAccount()?.idTokenClaims)
      })
  }

  checkAndSetActiveAccount() {

    let activeAccount = this.authService.instance.getActiveAccount();

    if (!activeAccount && this.authService.instance.getAllAccounts().length > 0) {
      let accounts = this.authService.instance.getAllAccounts();
      this.authService.instance.setActiveAccount(accounts[0]);
    }
  }

  setLoginDisplay() {
      
    this.loginDisplay = this.authService.instance.getAllAccounts().length > 0;
    this.getClaims(this.authService.instance.getActiveAccount()?.idTokenClaims)
  }

  getClaims(claims: any) {
    this.SpinnerService.show();
    
      if (claims != null) {
        var dto = {
                iata: claims['extension_IATA'],
                estadosolicitud: 2,
                nombreCompleto: claims['name'],
                identificacionTercero: claims['extension_id'],
                nombreTercero: claims['extension_businessArea'],
                areaNegocio: claims['extension_businessArea'],
                cargo: claims['extension_role'],
                Email: claims['email'],
                fechaCreacion: new Date(),
                creadoPor: 'System',
                idp:claims['idp']
              }
  
        if (localStorage.getItem("profile") == null) {

          var data: RequestData = new RequestData(JSON.stringify(dto));
           this.http.post<any>(window.location.origin + '/api/ValidateUser/ValidateProfile/', data).toPromise().then(
            res => { // Success
              let rta = res;   
              debugger;           
              if(rta.length==0){
                this.closeSession();
              }
              else if (rta.length>0 || rta.Head.Status != 'False' ) {
                localStorage.setItem("profile", JSON.stringify(rta));
                localStorage.setItem("ResponseData", JSON.stringify(dto));                
                this.SpinnerService.hide();
              }              
              else {
                this.SpinnerService.hide();
                Swal.fire({
                  position: 'center',
                  icon: 'error',
                  title: rta.Head.StackError,
                  showConfirmButton: false,
                  timer: 3000
                });
                localStorage.removeItem('ResponseData');
                localStorage.removeItem('profile');
                sessionStorage.clear();
              }  
            }
          ).catch(
            err => { // error
              console.error(err.toString());
            }
          );
        }
  
      }
    }
    private closeSession(){
      debugger;
      this.SpinnerService.hide();
      Swal.fire({
        title: 'Successful registration please check your email inbox',
        confirmButtonText: 'OK',        
      }).then((result) => {
        /* Read more about isConfirmed, isDenied below */
        if (result.isConfirmed) {
          if (this.msalGuardConfig.interactionType === InteractionType.Popup) {
            this.authService.logoutPopup({
              postLogoutRedirectUri: "/",
              mainWindowRedirectUri: "/"
            });
          } else {
            this.authService.logoutRedirect({
              postLogoutRedirectUri: "/",
            });
          }
          localStorage.removeItem('ResponseData');
          localStorage.removeItem('Claims');
          localStorage.removeItem('profile');
          sessionStorage.clear();
        } 
      })      
    }
  
  get UserInfo() {
    let UserInf: any;
    UserInf = localStorage.getItem("ResponseData");
    return UserInf ? UserInf : null;
  }

}
